<template>
  <div class="dialog-department-edit">
    <Form :model="formData" :label-width="140" ref="editDepartmentForm" :rules="validateRules">
      <FormItem label="手机号：" prop="mobile">
        <Input :maxlength= '18' v-model="formData.mobile" placeholder="请输入手机号" @on-blur="handleBlur"></Input>
      </FormItem>
      <div v-if="isShowForm">
        <FormItem label="姓名：" prop="name">
          <Input v-model="formData.name" placeholder="请输入姓名" :disabled="isDisabled"></Input>
        </FormItem>
        <FormItem label="证件类型：" prop="idCardType">
          <Select v-model="formData.idCardType" filterable :disabled="isDisabled">
            <Option v-for="option in cardList" :value="option.code" :key="option.code">{{option.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="证件号码：" prop="identityCard">
          <Input v-model="formData.identityCard" placeholder="请输入证件号码" :disabled="isDisabled"></Input>
        </FormItem>
  <!--      <FormItem label="角色" prop="role">-->
  <!--        <Select v-model="formData.role">-->
  <!--          <Option value="9">学院管理员</Option>-->
  <!--        </Select>-->
  <!--      </FormItem>-->
  <!--      <FormItem label="送审级别" prop="ssdwLevel">
          <Select v-model="formData.ssdwLevel">
            <Option value="2">二级</Option>
          </Select>
        </FormItem>-->
        <FormItem label="所属学院：" prop="department">
          <Select v-model="formData.department" filterable :disabled="isDisabled">
            <Option v-for="option in academyList" :value="option.id" :key="option.name">{{option.name}}</Option>
          </Select>
        </FormItem>
  <!--      <FormItem label="上级联系人" prop="superiorUserId">-->
  <!--        <Select v-model="formData.superiorUserId">-->
  <!--          <Option v-for="option in parentList" :key="option.userId" :value="option.userId">{{option.name}}</Option>-->
  <!--        </Select>-->
  <!--      </FormItem>-->
        <FormItem label="使用默认密码：" v-if="!query">
          <i-switch v-model="pwdSwitch">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
          （温馨提示：默认密码为手机号后6位，如需自定义密码，可选否）
        </FormItem>
        <FormItem v-if="!pwdSwitch" label="自定义密码：" prop="password">
          <Input type="password" v-model="formData.password" placeholder="请输入密码"></Input>
        </FormItem>
        <FormItem v-if="!pwdSwitch" label="确认密码：" prop="confirmPassword">
          <Input type="password" v-model="formData.confirmPassword" placeholder="请再次输入密码"></Input>
        </FormItem>
      </div>
    </Form>
    <Spin size="large" fix v-if="formLoading"></Spin>
  </div>
</template>

<script>
/* global FormItemRules:true */
export default {
  props: {
    query: ''
  },
  data () {
    const isPHONE = (rule, value, callback) => {
      if (value) {
        if (!this.formDefaultRules.isPHONE.test(value)) {
          return callback(new Error('输入的手机号不符合规则'));
        }
      }
      return callback();
    };
    const pwdCheckValidate = (rule, value, callback) => {
      if (this.formData.password !== '' && value === '') {
        callback(new Error('确认密码不能为空'));
      } else if (this.formData.password !== value) {
        callback(new Error('两次输入密码的不一致，请重新输入'));
      } else {
        callback();
      }
    }
    return {
      validateRules: {
        name: [{required: true, message: '姓名不能为空', trigger: 'blur'}],
        mobile: [{required: true, message: '手机号不能为空', trigger: 'blur'}, {validator: isPHONE, trigger: 'blur'}],
        // idCardType: [{required: true, message: '请选择证件类型', trigger: 'change'}],
        // identityCard: [{required: true, message: '请填写证件号码', trigger: 'blur'}],
        // schoolId: [{required: true, message: '请选择单位', trigger: 'change'}],
        // ssdwLevel: [{required: true, message: '请选择送审级别', trigger: 'change'}],
        department: [{required: true, message: '所属学院不可为空，下拉框无值请到"院系名称维护”页面添加', trigger: 'blur'}],
        // superiorUserId: [{required: true, message: '请选择上级联系人', trigger: 'blur'}],
        password: [{required: true, message: '请填写密码', trigger: 'blur'}],
        confirmPassword: [{required: true, validator: pwdCheckValidate, trigger: 'blur'}]
      },
      pwdSwitch: true,
      formData: {
        role: '9',
        password: '',
        confirmPassword: ''
      },
      defaultData: {},
      parentList: [],
      cardList: [],
      academyList: [],
      formLoading: true,
      formDefaultRules: {},
      isDisabled: false,
      isShowForm: false
    }
  },
  created () {
    this.formDefaultRules = FormItemRules;
    if (this.query) {
      this.initOptionList()
      this.fetchUserMsg();
    } else {
      this.initOptionList()
      this.formLoading = false
    }
  },
  methods: {
    handleBlur () {
      if (!this.formDefaultRules.isPHONE.test(this.formData.mobile)) {
        return new Error('输入的手机号不符合规则');
      } else {
        this.isShowForm = true
        this.fetch(`/sys/department/reviewUnitqueryByMobile/${this.formData.mobile}`).then(res => {
          if (res.data) {
            this.formData = res.data
            this.isDisabled = true
          } else {
            this.formData = {
              mobile: this.formData.mobile
            }
            this.isDisabled = false
          }
        })
      }
    },
    initOptionList () {
      this.fetchCardList()
      this.fetchAcademyList()
    },
    changeLevel () {
      this.formData.superiorUserId = null;
    },
    fetchCardList () {
      let url = 'conf/confIdCardType/all'
      this.fetch(url).then(res => {
        this.cardList = res.data // 证件类型
      })
    },
    fetchAcademyList () {
      let url = '/school/schoolAcademy/getAllAcademyByUser'
      this.post(url).then(res => {
        this.academyList = res.data
      })
    },
    fetchUserMsg () {
      const _self = this
      _self.fetch('/sys/user/info/' + this.query).then(res => {
        _self.formData = res.data
        _self.defaultData = JSON.parse(JSON.stringify(res.data))
        _self.formLoading = false;
      });
    },
    // 确定回调事件
    dialogComfirm () {
      const _self = this;
      return new Promise((resolve, reject) => {
        _self.$refs['editDepartmentForm'].validate((valid) => {
          if (valid) {
            let param = Object.compare(_self.defaultData, _self.formData);
            if (_self.defaultData.userId) {
              param.userId = _self.defaultData.userId
            } else {
              if (_self.pwdSwitch) {
                param.password = '123456';
              }
            }
            _self.post('/sys/department/saveOrUpdate', param).then(res => {
              resolve();
            }).catch(error => {
              reject(error);
            });
          } else {
            reject(new Error());
          }
        });
      });
    }
  }
}
</script>

<style lang='less'>

</style>



// WEBPACK FOOTER //
// src/layout/dialogs/systemManage/departmentEdit2.vue